import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyAODJ1d5ddSxynDvpfSfkzYndgQnhqsAY8",
    authDomain: "wpp-clone-cfe23.firebaseapp.com",
    databaseURL: "https://wpp-clone-cfe23.firebaseio.com",
    projectId: "wpp-clone-cfe23",
    storageBucket: "wpp-clone-cfe23.appspot.com",
    messagingSenderId: "311271408411",
    appId: "1:311271408411:web:78fd2049c84cb36c9a89be"
  };

  const fb= firebase.initializeApp(firebaseConfig);

  export const auth=firebase.auth()

 